/**
 * 상단/드롭다운 메뉴 공통 — 이동 가능한 href 판별 및 하위 메뉴 URL 해석
 */

export function isNavigableMenuHref(href) {
  return Boolean(href && href !== '#');
}

/**
 * 드롭다운 2depth 항목 클릭 URL (TopNavDropdownMenu·MegaMenu와 동일 규칙)
 * - 자신의 href가 있으면 사용
 * - 없으면 첫 번째 3depth 자식 href 사용
 */
export function resolveDropdownChildTargetUrl(child) {
  if (!child) return null;
  const firstChild = child.children?.[0];
  const firstChildHref = isNavigableMenuHref(firstChild?.href) ? firstChild.href : null;
  const childHref = isNavigableMenuHref(child.href) ? child.href : null;
  if ((!childHref || childHref === '#') && firstChildHref) return firstChildHref;
  return childHref || null;
}

/**
 * 1depth 항목의 하위 메뉴 중 첫 번째로 이동 가능한 URL
 */
export function resolveFirstActiveChildMenuUrl(parentItem) {
  if (!Array.isArray(parentItem?.children) || parentItem.children.length === 0) {
    return null;
  }
  for (const child of parentItem.children) {
    const target = resolveDropdownChildTargetUrl(child);
    if (target) return target;
  }
  return null;
}

/**
 * 상위 메뉴(1depth) 클릭 시 이동 URL — 활성(이동 가능) 첫 하위 메뉴 우선
 */
export function resolveTopMenuItemClickUrl(item) {
  const firstChildUrl = resolveFirstActiveChildMenuUrl(item);
  if (firstChildUrl) return firstChildUrl;
  return isNavigableMenuHref(item?.href) ? item.href : null;
}
